/**
 * Tekstene om gratisperioden med Plus.
 *
 * Ren tekst ut fra en dato, uten React, så de kan prøves for seg – og så
 * bjella, sidemenyen og Abonnement sier det samme med de samme ordene.
 */

const DAGFORMAT = new Intl.DateTimeFormat('nb-NO', { day: 'numeric', month: 'long' });

/** «18. november». Fristen er et tidspunkt, kunden tenker i dager. */
export function provesluttdato(iso: string): string {
  return DAGFORMAT.format(new Date(iso));
}

/** Er perioden over? Ugyldig eller manglende dato teller som over. */
export function proveErOver(iso: string | null | undefined, naa: Date = new Date()): boolean {
  if (!iso) return true;
  const slutt = new Date(iso);
  return Number.isNaN(slutt.getTime()) || slutt <= naa;
}

/**
 * Hvor mange dager som er igjen, slik et menneske teller dem.
 *
 * Kalenderdager, ikke døgn: slutter perioden i morgen ettermiddag, er det
 * «i morgen», selv om det er færre enn 24 timer igjen.
 */
export function dagerIgjen(iso: string, naa: Date = new Date()): number {
  const slutt = new Date(iso);
  const fra = new Date(naa);
  slutt.setHours(0, 0, 0, 0);
  fra.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((slutt.getTime() - fra.getTime()) / 86_400_000));
}

/** «i dag», «i morgen», «om 4 dager». */
export function nårDetSlutter(iso: string, naa: Date = new Date()): string {
  const dager = dagerIgjen(iso, naa);
  if (dager === 0) return 'i dag';
  if (dager === 1) return 'i morgen';
  return `om ${dager} dager`;
}

/**
 * Det bjella sier.
 *
 * To utgaver, fordi varselet blir stående: det som var «slutter 18. november»
 * da det kom, er «er over» for den som først åpner bjella en uke senere. Et
 * varsel som fortsatt sier «snart», når det for lengst har skjedd, er et
 * varsel man slutter å tro på.
 */
export function proveslutttekst(iso: string | null, naa: Date = new Date()): string {
  if (!iso || proveErOver(iso, naa)) {
    return 'Gratisperioden med Plus er over. Oppgrader for å få tilbake verktøyene i Plus.';
  }
  return (
    `Gratisperioden med Plus slutter ${provesluttdato(iso)}. ` +
    'Oppgrader for å fortsatt ha tilgang til verktøyene i Plus.'
  );
}
